import { render, staticRenderFns } from "./NewsIcon.vue?vue&type=template&id=33b523b2&scoped=true&"
import script from "./NewsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b523b2",
  null
  
)

export default component.exports